var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpCircleFilled = function SvgArrowUpCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "var(--primaryColor, #BA0C2F)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--tertiaryColor, #fff)",
    d: "m14 22 1.41 1.41L21 17.83V30h2V17.83l5.58 5.59L30 22l-8-8z"
  })));
};
export default SvgArrowUpCircleFilled;